import React from 'react';
import PropTypes from 'prop-types';

import ToggleButtonGroup from 'components/consumer/ToggleButtonGroup';
import ToggleTabGroup from 'components/consumer/ToggleTabGroup';
import Placeholder from 'components/consumer/Placeholder';
import MobileAndTabletOnly from '../MobileAndTabletOnly';
import DesktopOnly from '../DesktopOnly';

const ImportantToggle = ({
  'aria-label': ariaLabel,
  loading = false,
  items = [],
  onClick = () => {},
  selected,
}) => (
  <Placeholder
    loading={loading}
    type="rect"
    className="rounded mx-0 my-4 min-h-[45px] lg:m-0 lg:min-h-[60px]"
  >
    <MobileAndTabletOnly>
      <div className="min-h-[48px] lg:mt-3 lg:[border-top:1px_solid_#f1f1f1] lg:[border-bottom:1px_solid_#ccc] lg:hidden">
        <ToggleTabGroup
          aria-label={ariaLabel || ''}
          selectedTab={selected}
          items={items.map(
            ({ contentId, id, label, infoTooltip, infoTooltipContent }) => ({
              contentId,
              id,
              onClick: () => {
                onClick(id);
              },
              label,
              infoTooltip: !!infoTooltip,
              infoTooltipContent: infoTooltipContent || '',
            })
          )}
          styling="ImportantToggle"
        />
      </div>
    </MobileAndTabletOnly>

    <DesktopOnly>
      <div className="min-h-[48px] lg:mt-3 lg:[border-top:1px_solid_#f1f1f1] lg:[border-bottom:1px_solid_#ccc] max-[1023px]:hidden">
        <ToggleButtonGroup
          aria-label={ariaLabel || ''}
          selectedItem={selected}
          items={items.map(
            ({
              contentId,
              id,
              label,
              description,
              infoTooltip,
              infoTooltipContent,
            }) => ({
              contentId,
              id,
              onClick: () => {
                onClick(id);
              },
              label,
              description,
              infoTooltip: !!infoTooltip,
              infoTooltipContent: infoTooltipContent || '',
            })
          )}
          styling="ImportantToggle"
        />
      </div>
    </DesktopOnly>
  </Placeholder>
);

ImportantToggle.propTypes = {
  'aria-label': PropTypes.string,
  loading: PropTypes.bool,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      contentId: PropTypes.string.isRequired,
      id: PropTypes.string,
      label: PropTypes.string,
      description: PropTypes.string,
      infoTooltip: PropTypes.bool,
      infoTooltipContent: PropTypes.string,
    })
  ),
  onClick: PropTypes.func,
  selected: PropTypes.string,
};

export default ImportantToggle;
